/**
 * Mirrors com.platform.ctv.enums.FreewheelEntityType on the backend.
 *
 * Values are the wire form the API echoes back; the path segment sent is the
 * UPPERCASE key (see dspApi.refreshDspMetadata). The FreeWheel controller
 * accepts either spelling, but Adform's only accepts the key, so both are sent
 * the same way.
 */
export enum FreewheelEntityType {
  ADVERTISERS = 'advertisers',
  CAMPAIGNS = 'campaigns',
  LINE_ITEMS = 'line_items',
  CREATIVES = 'creatives',
  CREATIVE_LINE_ITEMS = 'creative_line_items',
  ALL = 'all',
}

export const FREEWHEEL_ENTITY_OPTIONS = [
  { label: 'Advertisers', value: FreewheelEntityType.ADVERTISERS },
  { label: 'Campaigns', value: FreewheelEntityType.CAMPAIGNS },
  { label: 'Line Items', value: FreewheelEntityType.LINE_ITEMS },
  { label: 'Creatives', value: FreewheelEntityType.CREATIVES },
  { label: 'Creative Line Items', value: FreewheelEntityType.CREATIVE_LINE_ITEMS },
  { label: 'All', value: FreewheelEntityType.ALL },
];
